<template>
	<v-card
		v-if="standDakChanges"
		class="contact-changes-card mb-6"
		outlined
	>
		<v-card-title
			class="contact-section-title"
			style="cursor: pointer;"
			@click="isExpanded = !isExpanded"
		>
			<v-icon class="mr-2">
				mdi-account-details
			</v-icon>
			Contact Details
			<v-spacer />
			<v-chip
				x-small
				color="primary"
				class="mr-2"
			>
				{{ standDakChanges.fields.length }} field{{ standDakChanges.fields.length !== 1 ? 's' : '' }}
			</v-chip>
			<v-icon>
				{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
			</v-icon>
		</v-card-title>
		<v-expand-transition>
			<v-card-text v-show="isExpanded">
				<div class="contact-details-info mb-3">
					<v-chip
						x-small
						color="primary"
						outlined
						class="mr-2"
					>
						Last Updated: {{ formatDate(standDakChanges.date) }}
					</v-chip>
					<span
						v-if="standDakChanges.logType"
						class="text-caption text--secondary"
					>
						{{ standDakChanges.logType }}
					</span>
				</div>
				<v-simple-table dense>
					<template #default>
						<thead>
							<tr>
								<th class="text-left">
									Field
								</th>
								<th class="text-left">
									Value
								</th>
								<th class="text-left">
									Last Updated
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(field, index) in standDakChanges.fields"
								:key="`field-${index}`"
							>
								<td class="font-weight-medium">
									<div class="d-flex align-center">
										{{ field.label }}
										<v-chip
											v-if="isFieldChangedOnSelectedDate(field)"
											x-small
											color="primary"
											class="ml-2"
										>
											New
										</v-chip>
									</div>
								</td>
								<td>
									{{ field.value }}
								</td>
								<td class="text-caption text--secondary">
									{{ formatDate(field.lastUpdated) }}
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>
		</v-expand-transition>
	</v-card>
</template>

<script>
import { format } from 'date-fns'
import { DATE_TIME_FORMAT } from '../../../../../../../shared/utils/date-formatting.js'

export default {
	props: {
		standDakChanges: {
			type: Object,
			default: null
		},
		selectedDate: {
			type: Date,
			default: null
		}
	},
	data () {
		return {
			isExpanded: false
		}
	},
	methods: {
		formatDate (date) {
			if (!date) return ''
			return format(new Date(date), DATE_TIME_FORMAT)
		},
		isFieldChangedOnSelectedDate (field) {
			if (!this.selectedDate || !field.lastUpdated) return false
			const fieldDate = new Date(field.lastUpdated)
			fieldDate.setHours(0, 0, 0, 0)
			const selectedDate = new Date(this.selectedDate)
			selectedDate.setHours(0, 0, 0, 0)
			return fieldDate.getTime() === selectedDate.getTime()
		}
	}
}
</script>

<style scoped>
.contact-changes-card {
	border: 1px solid var(--global-border-color);
}
.contact-section-title {
	font-size: 1.1rem !important;
	padding: 12px 16px !important;
}
.change-entry {
	border-left: 3px solid #3f51b5;
	padding-left: 12px;
}
.change-entry:not(:last-child) {
	border-bottom: 1px solid var(--global-border-color);
	padding-bottom: 16px;
}
.change-header {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
</style>
